/**
 * Single source of truth for the LeftNav menu.
 *
 * Each item carries `permission`, `division`, and (optional) `roles` fields.
 * Today the renderer ignores them (Super Admin has unrestricted access).
 * When RBAC is enabled later, the menu filter just needs to consult
 * `AuthContext.hasPerm(item.permission)` — no rewrite required.
 */
import {
  LayoutDashboard,
  ShieldAlert,
  Inbox,
  UserCog,
  Activity,
  Car,
  Wrench,
  ScanEye,
  LineChart,
  Camera,
  Settings,
} from "lucide-react";

export const MENU_GROUPS = [
  {
    key: "overview",
    label: "Overview",
    items: [
      { to: "/dashboard",      label: "Main Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", permission: "dashboard.view",       division: "executive" },
      { to: "/command-center", label: "Command Center", icon: ShieldAlert,     testid: "nav-command",   permission: "command.view",         division: "security"  },
    ],
  },
  {
    key: "security",
    label: "Security",
    items: [
      { to: "/incidents", label: "Incidents",    icon: Inbox,   testid: "nav-incidents", permission: "incidents.view", division: "security" },
      { to: "/vip",       label: "VIP Security", icon: UserCog, testid: "nav-vip",       permission: "vip.view",       division: "security" },
    ],
  },
  {
    key: "operations",
    label: "Operations",
    items: [
      { to: "/crowd",      label: "Crowd Intelligence",  icon: Activity, testid: "nav-crowd",      permission: "crowd.view",      division: "operations" },
      { to: "/parking",    label: "Parking Operations",  icon: Car,      testid: "nav-parking",    permission: "parking.view",    division: "operations" },
      { to: "/facilities", label: "Facility Management", icon: Wrench,   testid: "nav-facilities", permission: "facilities.view", division: "operations" },
    ],
  },
  {
    key: "intelligence",
    label: "Intelligence & AI",
    items: [
      { to: "/detection",  label: "Detection Intel",   icon: ScanEye,   testid: "nav-detection",  permission: "detection.view",  division: "ai" },
      { to: "/predictive", label: "Predictive Models", icon: LineChart, testid: "nav-predictive", permission: "predictive.view", division: "ai" },
    ],
  },
  {
    key: "infrastructure",
    label: "Infrastructure",
    items: [
      { to: "/cameras", label: "Cameras", icon: Camera, testid: "nav-cameras", permission: "cameras.view", division: "infrastructure" },
    ],
  },
  {
    key: "administration",
    label: "Administration",
    items: [
      { to: "/settings", label: "System Settings", icon: Settings, testid: "nav-settings", permission: "settings.manage", division: "admin" },
    ],
  },
];

/**
 * Helper: find which group contains a given route path.
 * Used to auto-expand the active section on first paint.
 */
export const findGroupForPath = (path) => {
  for (const g of MENU_GROUPS) {
    if (g.items.some((i) => i.to === path)) return g.key;
  }
  return MENU_GROUPS[0]?.key ?? null;
};
